import { HTMLAttributes, Ref } from 'react';

import styles from './styles.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
    spacing?: number;
    align?: 'center' | 'flex-start' | 'flex-end';
    justify?: 'center' | 'flex-start' | 'flex-end' | 'space-between' | 'space-around';
    fullWidth?: boolean;
    fullHeight?: boolean;
    as?: 'div' | 'section' | 'article' | 'main' | 'nav' | 'aside' | 'footer';
    ref?: Ref<HTMLDivElement>
}

function Column(props: Props) {
  const {
    spacing, align = 'flex-start',
    justify = 'flex-start',
    fullWidth = false,
    fullHeight = false,
    as = 'div',
    className,
    ...rest
  } = props;
  const Component = as;
  return (<Component className={`${styles.column}
  ${styles[`width-${fullWidth ? 'full' : 'auto'}`]}
  ${styles[`height-${fullHeight ? 'full' : 'auto'}`]}
  ${styles[`align-${align}`]}
   ${styles[`justify-${justify}`]}
   ${className}
  `}
                       style={{ rowGap: spacing ? `${spacing}px` : '0' }}
                       {...rest}
        />
  );
}

export default Column;
